import { get, post, url } from '../../service/ApiDecorator'

class Common {
  // 免登录
  @url('/app/auth/jwtLogInNew')
  @post
  jwtLogIn() { }

  // EOS获取回调url
  @url('/app/auth/getCallBackUrl')
  @post
  getCallBackUrl() { }

  // EOS获取获取用户信息
  @url('/app/auth/wxNew')
  @post
  wxNew() { }

  // 无用户访问系统，获取令牌token
  @url('/open/token')
  @get
  getTokenNoAuth() { }

  // 解析token，获取用户基本信息
  @url('/app/auth/decodeToken')
  @get
  decodeToken() { }

  // 移动端获取 数据应用 用户查询条件
  @url('/app/dataapp/v4/getDataAppCondition')
  @get
  getDataAppCondition() { }

  // 移动端获取 数据应用 用户查询结果
  @url('/app/dataapp/v4/getDataAppResultForCondition')
  @post
  getDataAppResultForCondition() { }
  // 移动端获取 数据应用 用户查询结果
  @url('v3/dataapp/getDataAppResultForCondition')
  @post
  getDataAppResultForConditionWebUse() { }

  // 移动端获取 数据应用 详情
  @url('/app/dataapp/v4/getReportDataAppDetail')
  @post
  getReportDataAppDetail() { }

  // 数据追踪-获取数据处理数据
  @url('/app/dataapp/v4/viewDetails')
  @post
  viewDetails() { }

  // 数据追踪-任务所有字段
  @url('/app/dataapp/v4/viewMoreDetails')
  @post
  viewMoreDetails() { }

  // 教师 测试
  @url('/app/tea/MyNotificationDetails')
  @post
  testTea() { }

  // 学生 测试
  @url('/app/stu/v1/personalCenter')
  @post
  testStu() { }

  // 获取老师列表信息---表格
  @url('/app/wx/common/getTeacherDetailList')
  @post
  getTeacherDetailList() { }

  // 获取老师详情信息 --title信息
  @url('/app/wx/common/getEOSTeacherInfo')
  @post
  getEOSTeacherInfo() { }

  // 场景任务内容
  @url('/app/wx/common/listFormValueResp')
  @post
  listFormValueResp() { }

  // 任务撤回
  @url('/app/stu/v1/recallFormValue')
  @get
  recallFormValue() { }
  // 判断任务是否含有引用
  @url('/v3/hasCiteFormItem')
  @get
  hasCiteFormItem() { }
  // 图像识别
  @url('/common/eos/face/search')
  @get
  imgIdentify() { }
  // 获取任务详情
  @url('/v3/getTaskDetail')
  @get
  getTaskDetail() { }
  // 通过taskId获取任务信息
  @url('/v3/admin/common/getSimpleTaskInfoById')
  @post
  getSimpleTaskInfoById() { }
  // 获取任务信息
  @url('/app/task/getTaskDataDetail')
  @get
  getTaskDataDetail() { }
  // 获取任务信息
  @url('/app/visitor/getVisitorTaskDetail')
  @get
  getVisitorTaskDetail() { }
  // 获取周期列表
  @url('/app/stu/v1/getTaskCycleState')
  @get
  getTaskCycleState() { }
  // 判断任务是否访客任务
  @url('/app/visitor/getVisitorTypeByTaskId')
  @get
  getVisitorTypeByTaskId() { }
  // 访客高级设置参数
  @url('/app/visitor/getVisitorIntroduceByTaskId')
  @get
  getVisitorIntroduceByTaskId() { }
}

export default new Common()
